export function toQueryString(params: Record<string, string | number | null | undefined>): string {
    const entries: [string, string][] = []
    for (const [k, v] of Object.entries(params)) {
        if (v === null || v === undefined) continue
        entries.push([k, String(v)])
    }
    return new URLSearchParams(entries).toString()
}
